import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-diamond02",
  "use": "icon-diamond02-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-diamond02\">\n<path d=\"M12 11L8.5 7.5L12 4L15.5 7.5L12 11ZM16.5 15.5L13 12L16.5 8.5L20 12L16.5 15.5ZM7.5 15.5L4 12L7.5 8.5L11 12L7.5 15.5ZM12 20L8.5 16.5L12 13L15.5 16.5L12 20Z\" fill=\"black\" fill-opacity=\"0.38\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol